import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { usePageMeta } from '../hooks/usePageMeta';
import { useLocalizedPath } from '../hooks/useLocalizedPath';
import { useI18nLocaleSync } from '../hooks/useI18nLocaleSync';
import { useAppLocale } from '../hooks/useAppLocale';
import { pathWithLocale } from '../lib/locale';
import { TermsBodyEn, TermsBodyKo } from './content/TermsPrivacyBodies';

export function Terms() {
  const { t } = useTranslation();
  const locale = useAppLocale();
  const lp = useLocalizedPath();

  useI18nLocaleSync();

  usePageMeta({
    title: locale === 'ko' ? '이용약관 – 로또 번호 생성기' : t('termsPage.metaTitle'),
    description: locale === 'ko' ? '로또 번호 생성기 이용약관입니다.' : t('termsPage.metaDesc'),
    path: pathWithLocale('/terms', locale),
    noindex: locale !== 'en' && locale !== 'ko',
  });

  return (
    <main className="content">
      <nav className="breadcrumb" aria-label={t('layout.breadcrumbLabel')}>
        <Link to={lp('/')}>{t('breadcrumb.home')}</Link>
        <span className="sep">/</span>
        <span className="current">{t('nav.terms')}</span>
      </nav>

      {locale === 'ko' ? <TermsBodyKo lp={lp} /> : <TermsBodyEn lp={lp} />}
    </main>
  );
}
